<template>
  <transition
    appear
    v-on:leave="leave"
    v-on:enter="enter"
    v-bind:css="false" >
    <section class="About" v-show="isOpened">
      <div class="About-overlay" ref="overlay"></div>
      <div class="About-page">
        <div class="About-page-bg" ref="wrapper"></div>
        <div @click="onClose">
          <CloseButton dark ref="closebtn"/>
        </div>
        <div class="About-wrapper" v-click-outside="onClose">
          <div class="About-content" ref="content">
            <prismic-rich-text v-if="data.title"  :field="data.title" />
            <prismic-rich-text v-if="data.presentation" :field="data.presentation" />
            <div class="About-separation"></div>
            <prismic-rich-text v-if="data.sources" :field="data.sources" />
            <div class="About-separation"></div>
            <prismic-rich-text v-if="data.credits" :field="data.credits" />
          </div>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
import CloseButton from '@/components/CloseButton.vue'
import gsap from 'gsap'

export default {
  components: {
    CloseButton
  },
  props: {
    data: Object,
    outclose: Function
  },
  data () {
    return {
      tl: null,
      isOpened: false
    }
  },
  beforeDestroy () {
    this.isOpen = false
    // this.onClose()
    if (this.tl) this.tl.kill()
  },
  methods: {
    onClose (e) {
      this.outclose(e)
      // this.close()
    },
    open () {
      this.isOpened = true
    },
    close () {
      this.isOpened = false
    },
    enter (e, done) {
      // if (this.tl) this.tl.clear()
      this.tl = gsap.timeline({
        onComplete: () => {
          done()
        }
      })
      this.tl.fromTo(this.$el, { duration: 0.1, alpha: 0, display: 'none' }, { display: 'block', alpha: 1 }, 0)
      this.tl.fromTo(this.$refs.overlay, { duration: 0.6, alpha: 0 }, { alpha: 1 }, 0)
      this.tl.fromTo(this.$refs.wrapper, { duration: 0.2, width: '100%', scaleY: 0, transformOrigin: 'bottom center', ease: 'power3.out' }, { scaleY: 1 }, 0)
      this.tl.fromTo([this.$refs.content, this.$refs.closebtn.$el], { alpha: 0 }, { duration: 0.4, alpha: 1, stagger: 0.2 }, 0.4)
    },
    leave (e, done) {
      // this.tl.kill()
      // this.tl = gsap.timeline({
      //   onComplete: () => {
      //     done()
      //   }
      // })
      // this.tl.fromTo(this.$el, { duration: 0.6, alpha: 1 }, { alpha: 0 }, 0)
      this.tl.reverse()
    }
  }
}
</script>

<style lang="stylus">
.About
  position absolute
  top 40px
  left 0
  height calc(100% - 81px)
  width 100%
  z-index 100

  &-overlay
    position absolute
    top 0
    left 0
    height 100%
    width 100%
    background rgba(0, 0, 0, 0.4)
    opacity 0
  &-content
  .CloseButton
    opacity 0

  &-page
    position relative
    min-width 600px
    width 45%
    height 100%
    float right
    &-bg
      position absolute
      top 0
      right 0
      height 100%
      width 0
      background white
    .CloseButton
      position absolute
      top 3vw
      left 3.6vw
  &-wrapper
    position relative
    width 100%
    height 100%
    padding 3vw 5vw
    padding-left 9vw
    color black
    line-height 1.6
    overflow-y scroll

    h1
      font-size 1.1rem
      font-family 'LeagueMonoBold'
      text-align center
      text-transform uppercase
      margin-bottom 30px
    p
      margin 30px 0
      strong
        font-family 'LeagueMonoBold'
      em
        color red
      a
        text-decoration none
        display inline-block
        border-bottom 1px solid black
        transition all 200ms linear
        margin-bottom 5px
        &:hover
          border-bottom 1px solid red
    &:last-child
      p
        margin-bottom 0
  &-separation
    height 1px
    width 30px
    margin 30px 0
    background black

@media(max-width: 600px)
  .About
    position fixed
    top 0
    left 0
    height calc(100% - 22px)
    width 100%
    z-index 100
    overflow hidden
    &-page
      width 100%
      min-width 300px
    &-wrapper
      overflow-x hidden
      line-height 1.5
      font-size 0.8rem
      padding 20px 50px

</style>
